import React, { PureComponent, useEffect, useState } from "react";
import flag_2 from "./../assets/img/tarh-parcham-iran-psdtarh2.png";
import { ApiEndpoints, useApiCall } from "../api";
import MainLayout from "../layout/main";

import {
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  BarChart,
  Bar,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { SelectOption } from "../component/selectOption";
import { storageApi } from "../storage/storageApi";

const ReportPage = () => {
  const [reportData, setReportData] = useState([]);
  const [report, setReport] = useState("programs");
  const [reportBy, setReportBy] = useState("monasebat");
  const userProfile = storageApi.useGetUser();

  const [[reportList], { loading, fetch: getReportApi }] = useApiCall({
    endpoints: ApiEndpoints.statistics.admin,
    payload: {
      report: report,
      reportBy: reportBy,
    },
  });

  const reportOptions = [
    { label: "برنامه ها", value: "programs" },
    { label: "مجموع امتیازات", value: "score" },
    {
      label: "تعداد کاربران",
      value: "active_user",
      isHide: reportBy === "monasebat" || userProfile.role === "customer",
    },
  ];

  const reportByOptions = [
    { label: "مناسبت ها", value: "monasebat" },
    {
      label: "شهرستان",
      value: "city",
      isHide:
        userProfile.role === "admin" ||
        userProfile.role === "organization_manager",
    },
    {
      label:
        userProfile.role === "state_manager" ||
        userProfile.role === "organization_manager" ||
        userProfile.role === "state_organization_manager"
          ? "زیرمجموعه"
          : "زیرمجموعه در استان",
      value: "sazman",
      isHide: userProfile.role === "admin",
    },
    {
      label:
        userProfile.role === "admin" ||
        userProfile.role === "state_organization_manager"
          ? "مجموعه"
          : userProfile.role === "state_manager"
            ? "مجموعه"
            : userProfile.role === "organization_manager"
              ? "کشوری"
              : "مجموعه ها در استان",
      value: "majmooe",
    },
    {
      label:
        userProfile.role === "state_manager" ||
        userProfile.role === "state_organization_manager"
          ? "کشوری"
          : "استان",
      value: "state",
    },
  ];
  useEffect(() => {
    let repData = [];
    if (reportList?.data) {
      repData = Object.values(reportList?.data);
      repData.map((rep) => {
        if (rep.title.length > 6) {
          rep.sTitle = rep.title.substring(0, 6) + "...";
        }
      });
      setReportData(repData);
    }
  }, [reportList?.data]);

  useEffect(() => {
    if (report === "active_user" && reportBy === "monasebat") {
      setReport("programs");
    }
    getReportApi();
  }, [report, reportBy]);

  const handleDataKey = () => {
    switch (report) {
      case "programs":
        return "planned_programs";
      case "score":
        return "total_score";
      case "active_user":
        return "active_user_count";
    }
  };

  const handleSecondDataKey = () => {
    switch (report) {
      case "programs":
        return "approved_programs";
      case "active_user":
        return "registered_user_count";
    }
  };

  const handleDataName = () => {
    switch (report) {
      case "programs":
        return "برنامه های پیش بینی شده";
      case "score":
        return "مجموع امتیاز";
      case "active_user":
        return "تعداد کاربران فعال";
    }
  };

  const handleSecondDataName = () => {
    switch (report) {
      case "programs":
        return "گزارش تایید شده(اجرا شده)";
      case "active_user":
        return "کاربران ثبت نام شده";
    }
  };

  class CustomizedAxisTick extends PureComponent {
    render() {
      const { x, y, stroke, payload } = this.props;

      return (
        <g transform={`translate(${x},${y})`}>
          <text transform="rotate(270)">{payload.value}</text>
        </g>
      );
    }
  }

  return (
    <MainLayout>
      <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 h-full shadow-sm w-full">
        <div className="sec1 w-full bg-greenblue-light h-auto rounded-3xl relative p-8 min-h-[180px]">
          <img src={flag_2} className=" absolute left-0 top-0 h-42" />
          <div className="flex flex-col gap-8 justify-center items-center w-[60%] h-full mx-auto">
            <div className="text-3xl text-center font-bold">
              <span className=" text-greenblue">گزارش های نموداری</span>
            </div>
          </div>
        </div>

        <div className="flex justify-center">
          <div className="flex flex-col w-[300px] p-3 ">
            <SelectOption
              classLabel="text-slate-800  font-bold"
              classInput="w-full"
              className=" w-[200px] p-3 rounded-lg"
              label={"گزارش نمودار:"}
              value={report}
              options={reportOptions}
              onChange={(e) => {
                setReport(e.value);
              }}
            />
          </div>
          {userProfile.role !== "customer" && (
            <div className="flex flex-col w-[300px] p-3 ">
              <SelectOption
                classLabel="text-slate-800  font-bold"
                classInput="w-full"
                className=" rounded-lg"
                label={"بر اساس:"}
                value={reportBy}
                options={reportByOptions}
                onChange={(e) => {
                  setReportBy(e.value);
                }}
              />
            </div>
          )}
        </div>
        <div
          style={
            window.innerWidth > 992
              ? {
                  maxWidth: "calc(130vw)",
                  overflow: "auto",
                  height: "700px",
                  direction: "ltr",
                }
              : {
                  overflow: "auto",
                  height: "700px",
                  direction: "ltr",
                }
          }
        >
          <ResponsiveContainer
            width={reportData.length < 10 ? "100%" : "200%"}
            height={700}
            style={{ direction: "rtl" }}
          >
            <BarChart
              width={800}
              height={700}
              data={reportData}
              margin={{ top: 0, bottom: 200 }}
            >
              <Legend verticalAlign="top" />
              <XAxis
                dataKey="title"
                stroke="#3F952C"
                orientation="bottom"
                angle="270"
                padding={{ left: 20, right: 20 }}
                tick={<CustomizedAxisTick />}
              />
              <YAxis style={{ direction: "ltr" }} />
              <Tooltip />
              <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
              <Bar
                dataKey={handleDataKey()}
                fill="#4C243B"
                barSize={60}
                name={handleDataName()}
                label={{ position: "top", offset: 15 }}
                width={200}
              />
              {(report === "programs" || report === "active_user") && (
                <Bar
                  dataKey={handleSecondDataKey()}
                  fill="#D197DE"
                  barSize={60}
                  name={handleSecondDataName()}
                  label={{ position: "top" }}
                />
              )}
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </MainLayout>
  );
};

export default ReportPage;
